import React from "react";
import graph from "./graph";
import Update from "./Update";

import {
  Fade,
  Card,
  Stack,
  Typography,
  CardHeader,
  CardActions,
  CardActionArea,
} from "@mui/material";

import { useSelector } from "react-redux";
import { hasRequiredRole } from "helpers";
import { FormattedMessage } from "react-intl";
import { AvatarPopover, NewMediaPopup } from "components";

export default function Model({
  model,
  delay,
  checked,
  refetch,
  isAssign,
  selectable,
  handleSelect,
}) {
  const { id, media, title, state } = model;
  const { userInfo } = useSelector((state) => state.auth);
  const isSuperadmin = hasRequiredRole(
    ["superadmin", "operator"],
    userInfo?.roles
  );
  return (
    <>
      <Fade
        in
        unmountOnExit
        timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}
      >
        <Stack direction="row" alignItems="center">
          <Card
            sx={{
              width: "100%",
              position: "relative",
              borderColor: checked && "primary.main",
              bgcolor: checked && "action.disabledBackground",
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              avatar={
                <NewMediaPopup
                  id={id}
                  title={title}
                  graph={graph}
                  model="State"
                  collection="avatar"
                >
                  <AvatarPopover
                    isAssign={isAssign}
                    media={media[0]?.full_url}
                    sx={{ width: 48, height: 48 }}
                  />
                </NewMediaPopup>
              }
              title={title}
              action={<Typography variant="caption">{state?.title}</Typography>}
            />
            <CardActions sx={{ justifyContent: "flex-end" }}>
              {isSuperadmin && (
                <Update
                  ids={model.id}
                  refetch={refetch}
                  title={<FormattedMessage id="update" />}
                />
              )}
            </CardActions>
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: "absolute",
              }}
              onClick={handleSelect}
              disabled={!isAssign && !selectable}
            />
          </Card>
        </Stack>
      </Fade>
    </>
  );
}
